fx.ns("shared.social", class SocialPhotosGallery extends fx.Component
{
	constructor(props)
	{
        super(props.data);

		this._service = props.service;
		this._assets = props.assets;
		this._width = props.width;
		this._height = props.height;
		this._currentAlbumName = null;
	}
	
	// ------------- RENDER -------------- //

    create()
	{
		// Photos
		this.photosContainer = new fx.components.Box('photos-container');
		this.addChild(this.photosContainer, {width: '100%', height: '100%'});
		this._insertPhotos();

		// Spinner
		this.photosLoader = new fx.components.Image({data: this._assets.loader, className:"spinner" });

		if (this.photosContainer.getChilds().length == 0)
			this.photosContainer.addChild(this.photosLoader, {width: 40, height:40, top:'center', right:'center'});
	}

	onReady()
	{
		this.on("scroll",this.doLazyLoad, this.photosContainer);
		this.on("photos-loaded", this._checkLastPhoto, this._service);
	}

	// ------------- HANDLERS -------------- //

	doLazyLoad(force)
	{
		if (this.data.lazyLoadingActive === 1) return;
		
		let containerClientHeight = this.find(".photos-container").clientHeight;
		let containerScrollTop = this.find('.photos-container').scrollTop;
		let containerScrollHeight = this.find('.photos-container').scrollHeight;
		
		let album = this.data.currentAlbum ? this.data.currentAlbum : this.data;
		
		if (force === true || (containerClientHeight + containerScrollTop > containerScrollHeight - 100) )
		{
			if (album.nextPhotos)
			{
				this.data.lazyLoadingActive = 1

                if (this.photosLoader)
                    this.photosContainer.removeChild(this.photosLoader);

                this.photosContainer.addChild(this.photosLoader, {width: 40, height:40, top: (containerScrollHeight - 100), right:'center'});

				this._service.getPhotos(album);
			}
		}
	}

	// ------------- METHODS -------------- //

	addNewPhotos(photos)
	{
		let lastItemNumber = this.photosContainer.getChilds().length;

		if(photos.getItemAt(lastItemNumber))
		{
			let item = photos.getItemAt(lastItemNumber);

			this.photosContainer.addChild(new shared.renderers.SocialPictureRenderer({data: item}), {width: this._width, height: this._height});
		}
	}

	_checkLastPhoto()
	{
		let lastPhoto = this.photosContainer.getChilds().last();

		let position = fx.dom.position(lastPhoto);
		if(position && position.top){
			if(position.top != null){
				if (position.top < this.photosContainer.measuredHeight())
					this.doLazyLoad(true);
			}
		}
	}

	_insertPhotos()
	{
		// currentAlbum for Facebook and Google; this.data for Instagram
		let photos = this.data.currentAlbum ? this.data.currentAlbum.photos : this.data;

		for ( let i = 0; i < photos.length; i++)
		{
			let item = photos.getItemAt(i);
            
			this.photosContainer.addChild(new shared.renderers.SocialPictureRenderer({data: item}), {width: this._width, height: this._height});
		}
	}

	changeAlbum()
	{
		let newCurrentAlbumName = this.data.currentAlbum.name;
		
		if (this._currentAlbumName === newCurrentAlbumName) return;

		if (this.photosLoader)
			this.photosContainer.removeChild(this.photosLoader);

		let i = this.photosContainer.getChilds().length - 1;

		while (i >= 0) {
			let item = this.photosContainer.getChilds()[i];
			this.removeChild(item, true);
			
			i--;
		}

		if (!this.data.currentAlbum.photos.length)
		{
			this.photosContainer.addChild(this.photosLoader, {width: 40, height:40, top:'center', right:'center'});
		}
		
		this._currentAlbumName = newCurrentAlbumName;

		this._insertPhotos()
	}

	// ------------- EVENTS -------------- //

	onDataUpdated(action)
	{
		if (action.type === 'addItem' && action.model instanceof repositories.InstagramRepository)
		{
			// this.photosContainer.loading(false);
			if (this.photosLoader)
				this.photosContainer.removeChild(this.photosLoader);

			this.addNewPhotos(this.data);
		}
	}

	onChildUpdated(action)
	{
		if (action.type === 'addItem')
		{
			if (this.photosLoader)
				this.photosContainer.removeChild(this.photosLoader);

			this.addNewPhotos(this.data.currentAlbum.photos);
		}
		
		if (action.type === 'update' && action.data.isActive === true)
		{
			this.changeAlbum();
		}
	}

});